<template>
    <p class="field">
        <input type="submit" class="btn" :value="'Uložit' | translate" @click.prevent.stop="$emit('submit')">
    </p>
</template>

<script>
	export default {
		name: "ButtonInput"
	}
</script>



// WEBPACK FOOTER //
// src/components/common/ButtonInput.vue